/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/display-name */
import React, {useContext, useEffect, useRef, useState} from 'react';
import useCommon from '@utils/hooks/common';
import {PositionContext} from '@utils/context';
import MovableObject from '@components/MovableObject';
import ChipsImage from '@components/ChipsImage';
import MultiUnitStatistic from '../MultiUnitStatistic';
import {TABLET_BREAKPOINT} from '@constant/system';
import styles from './styles';
import {CHIP_POSITION} from '../TableAreaMobile/styles';
import {AnimatePresence, motion} from 'framer-motion';
// import Poker from '@components/Poker';
// import classnames from 'classnames';

interface MovableChipInterface {
  isAllIn?: boolean;
  chipWrapperClassName?: string;
  chipAmount?: number;
}

const MovableChip = React.forwardRef((props: MovableChipInterface, ref) => {
  const {classes, game, theme} = useCommon({
    withStyles: styles,
    observers: ['socket', 'game'],
  });
  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';

  const {isAllIn, chipAmount, chipWrapperClassName} = props;

  const chipDivRef = useRef<HTMLDivElement>();

  const {componentsPositions, scaleUpValue} = useContext(PositionContext);

  const getLeftDest = () => {
    // if (!chipDivRef?.current) return;
    if (typeof window === 'undefined') return;
    if (componentsPositions?.chips?.left && componentsPositions?.chips?.left > 0) {
      const {left, right} = componentsPositions?.chips;
      const width = right - left;
      const centerLeft = left + width / 2;

      return centerLeft;
    }
    return 0;
  };

  const getTopDest = () => {
    if (typeof window === 'undefined') return;
    if (componentsPositions?.chips?.top && componentsPositions?.chips?.top > 0) {
      const {top, bottom} = componentsPositions?.chips;
      const height = bottom - top;
      const centerTop = top + height / 2;

      return centerTop;
    }
    return 0;
  };
  // TODO @@ chips
  // console.log('chipAmount', chipAmount);
  // console.log('componentsPositions?.chips in MovableChip', componentsPositions?.chips);

  return (
    <MovableObject
      ref={ref}
      // * chips positions
      // destination refers to absolute position of window size
      destination={{
        left: getLeftDest(),
        top: getTopDest(),
      }}
    >
      <div ref={chipDivRef} className={classes.chipsWrapper}>
        <ChipsImage chipAmount={chipAmount} />
        {chipAmount && chipAmount > 0 ? (
          <div className={classes.currentBet}>
            <MultiUnitStatistic
              value={chipAmount}
              valueStyle={{color: 'white', fontSize: isDesktop ? '8px' : '12px'}}
            />
          </div>
        ) : null}
      </div>
    </MovableObject>
  );
});

export default React.memo(MovableChip, (prevProps, nextProps) => {
  if (!prevProps || !nextProps) return false;
  if (prevProps.chipAmount === nextProps.chipAmount) return true;
  return false;
});
